import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Drawer from "@mui/material/Drawer";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
//Limitless imports
import { useAppConfig } from "@limitless/common/hooks";
import { useSettingsDrawer } from "@limitless/common/hooks/settings-drawer/SettingsDrawerHook";
import { useManagerProfileContext } from "../../../../manager/hooks/manager-profile/ManagerProfileContext";
import AutoComplete from "../../form-elements/auto-complete/AutoComplete";
import { createSuggestions } from "../../../utils/AutoCompleteDataUtil";
const useStyles = makeStyles({
  drawer: {
    top: 64,
    width: 400
  },
  formLabelStyle: {
    textAlign: "center",
    padding: "20px 0 10px 0",
    fontSize: 18
  },
  itemStyle: {
    width: "85%",
    margin: "5px auto"
  }
});
const ManagerSettings = ({
  children,
  timeZoneDisabled
}) => {
  const {
    updateManagerTimeZone,
    managerProfile
  } = useManagerProfileContext();
  const {
    isDrawerOpen,
    toggleSettingsDrawer
  } = useSettingsDrawer();
  const {
    config: {
      timeZones
    }
  } = useAppConfig();
  const classes = useStyles();
  const handleTimeZoneChange = timeZone => {
    updateManagerTimeZone(timeZone);
    toggleSettingsDrawer();
  };
  const timeZoneList = createSuggestions(timeZones, {
    labelDataKey: "timeZone",
    valueDataKey: "timeZoneDescription"
  });
  const selectedTimeZone = timeZoneList.find(tz => tz.value === managerProfile.timeZone.value);
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: isDrawerOpen,
    onClose: toggleSettingsDrawer,
    classes: {
      paperAnchorRight: classes.drawer
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    column: "true"
  }, /*#__PURE__*/React.createElement(FormLabel, {
    className: classes.formLabelStyle,
    component: "div"
  }, "Date & Time", /*#__PURE__*/React.createElement(Divider, {
    className: classes.itemStyle
  }))), /*#__PURE__*/React.createElement(FormGroup, {
    column: "true",
    className: classes.itemStyle
  }, /*#__PURE__*/React.createElement(AutoComplete, {
    label: "Time Zone",
    value: selectedTimeZone || timeZoneList[0],
    id: "timeZoneList",
    suggestions: timeZoneList,
    onChange: handleTimeZoneChange,
    name: "timeZoneList",
    isSearchable: false,
    disabled: timeZoneDisabled
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, timeZoneDisabled ? "Time Zone selection disabled for this portal" : "All date/times will be formatted to this timezone")), children);
};
export default ManagerSettings;
ManagerSettings.propTypes = {
  children: PropTypes.node,
  timeZoneDisabled: PropTypes.bool
};
ManagerSettings.defaultProps = {
  timeZoneDisabled: false
};